var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3HeatingLevel12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 7v21h-4V14h-6v-2.83c.754.02 1.508-.036 2.25-.17a6.232 6.232 0 002-.69A4.49 4.49 0 0064.68 9a4.62 4.62 0 00.77-2H69zM23 48.93L12.71 38.87 21.19 29h-5.27L7.23 39.11l10.07 9.82-10.07 9.81L16 69h5.27l-8.56-10L23 48.93zm12.58 0L25.29 38.87 33.77 29h-5.28L19.8 39.11l10.08 9.81-10.08 9.82L28.62 69h5.28l-8.61-10 10.29-10.07zm12.58 0L37.87 38.87 46.34 29h-5.27l-8.69 10.11 10.08 9.81-10.08 9.82L41.2 69h5.27l-8.6-10 10.29-10.07zm2.25-10.06L58.92 29h-5.27L45 39.11l10 9.82-10 9.81L53.78 69h5.27l-8.61-10 10.33-10.07-10.36-10.06z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Heating_level_1-2.3df56f1d.svg";
export { SvgB3HeatingLevel12 as ReactComponent };